import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { UseFormReturn } from 'react-hook-form'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { repayValidationIssueToMessage, validateRepay } from '@/domain/market-validators/validateRepay'
import { MyWalletProps } from '@/features/isolated-details/components/my-wallet/MyWallet'
import BigNumber from 'bignumber.js'

export interface GetRepayDialogFormValidatorOptions {
  walletOverview: MyWalletProps
}

export function getRepayDialogFormValidator({ walletOverview }: GetRepayDialogFormValidatorOptions) {
  return AssetInputSchema.superRefine((field, ctx) => {
    const value = NormalizedUnitNumber(field.value === '' ? '0' : field.value)

    const validationIssue = validateRepay({
      value,
      asset: {
        status: 'active',
      },
      user: {
        debt: walletOverview.repay!.available,
        balance: walletOverview.depositBorrowAsset!.available,
      },
    })

    if (validationIssue) {
      ctx.addIssue({
        code: 'custom',
        path: ['value'],
        message: repayValidationIssueToMessage[validationIssue],
      })
    }
  })
}

export function getFormFieldsForRepayDialog(
  form: UseFormReturn<AssetInputSchema>,
  token: Token,
  available: NormalizedUnitNumber,
  balance: NormalizedUnitNumber,
): FormFieldsForDialog {
  const changeAsset = (newSymbol: TokenSymbol): void => {
    form.setValue('symbol', newSymbol)
    form.setValue('value', '')
    form.clearErrors()
  }

  const { value } = form.getValues()

  const availableValue = available.lt(balance) ? available : NormalizedUnitNumber(balance.dp(6, BigNumber.ROUND_DOWN))

  return {
    selectedAsset: {
      value,
      token,
      balance: availableValue,
    },
    maxSelectedFieldName: 'isMaxSelected',
    changeAsset,
    maxValue: availableValue,
    displayBalance: availableValue,
  }
}
